import { useAppContext } from '@/context/app';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import { useCallback, useEffect, useState } from 'react';

export const LinkGroup = () => {
  const [activeSection, setActiveSection] = useState<string>('');
  const [{ isSticky }] = useAppContext();

  const { isMobile, isDesktop } = useIsMobile();

  const buttonClass =
    'cursor-pointer border-1 border-[#E0E0E0] flex h-[26px] w-fit items-center justify-center rounded-full border-solid px-[6px] text-[14px] whitespace-nowrap text-[#929292]';

  const desktopClass =
    'transition-border duration-300 cursor-pointer font-roboto-medium font-medium text-[16px] h-[43px] border-b-2 border-transparent border-solid flex items-center justify-center';

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        'duration',
        'coverage',
        'restrictions',
        'one-unconditional-free-replacement',
        'customer-benefits',
        'warranty-registeration',
        'contact-us',
      ];

      for (const section of sections) {
        const element = document.getElementById(section);

        if (element) {
          const rect = element.getBoundingClientRect();
          // console.log('handleScroll', section, rect.top, rect.bottom);
          if (rect.top <= window.innerHeight * 0.5 && rect.bottom >= window.innerHeight * 0.5) {
            // if (rect.top <= 400 && rect.bottom >= 400) {
            setActiveSection(section);
            break;
          }
        }

        if (window.scrollY <= 100) {
          setActiveSection('duration');
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // 初始调用一次以设置初始状态
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = useCallback(
    (elementId: string) => {
      const sections = {
        duration: 0,
        coverage: 40,
        restrictions: 50,
        'one-unconditional-free-replacement': 80,
        'customer-benefits': 50,
        'warranty-registeration': 50,
        'contact-us': 60,
      };
      const getHeaderHeight = () => {
        if (isMobile) return isSticky ? 160 : 100;
        return isSticky ? 141 : 78;
      };
      const element = document.getElementById(elementId);
      const offset = sections[elementId]; // Adjust this value based on your needs
      if (element) {
        const offsetTop = isSticky ? offset + 78 : offset; // Adjust this value based on your needs
        const elementPosition = element.getBoundingClientRect().top;
        console.log('offsetTop', elementPosition, offsetTop);
        const offsetPosition = elementPosition + window.pageYOffset - getHeaderHeight();

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    },
    [isSticky],
  );

  if (isDesktop) {
    return (
      <div className={cn('sticky z-[3] w-full bg-white', isSticky ? 'top-[78px] ' : 'top-[-1px] ')}>
        <div className='personalContent  mx-auto border-b-1 border-solid border-[#ccc] '>
          <div className=' flex justify-between'>
            <div
              onClick={() => scrollToSection('duration')}
              className={cn(desktopClass, activeSection === 'duration' ? 'border-[#000]' : '')}
            >
              Warranty Duration
            </div>
            <div
              onClick={() => scrollToSection('coverage')}
              className={cn(desktopClass, activeSection === 'coverage' ? 'border-secondary' : '')}
            >
              Coverage
            </div>
            <div
              onClick={() => scrollToSection('restrictions')}
              className={cn(desktopClass, activeSection === 'restrictions' ? 'border-secondary' : '')}
            >
              Restrictions
            </div>
            <div
              onClick={() => scrollToSection('one-unconditional-free-replacement')}
              className={cn(
                desktopClass,
                activeSection === 'one-unconditional-free-replacement' ? 'border-secondary' : '',
              )}
            >
              <span className='text-secondary'>ONE&nbsp;</span> Unconditional{' '}
              <span className='text-secondary'>&nbsp;FREE&nbsp;</span> Replacement
            </div>
            <div
              onClick={() => scrollToSection('customer-benefits')}
              className={cn(desktopClass, activeSection === 'customer-benefits' ? 'border-secondary' : '')}
            >
              Customer Benefits
            </div>
            <div
              onClick={() => scrollToSection('warranty-registeration')}
              className={cn(desktopClass, activeSection === 'warranty-registeration' ? 'border-secondary' : '')}
            >
              Warranty Registration
            </div>
            <div
              onClick={() => scrollToSection('contact-us')}
              className={cn(desktopClass, activeSection === 'contact-us' ? 'border-secondary' : '')}
            >
              Contact Us
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('sticky z-[3] w-full bg-white', isSticky ? 'top-[50px] ' : 'top-[0] ')}>
      <div
        datatype='title'
        className='flex  flex-wrap gap-[10px] px-[10px] py-[20px]'
        style={{ boxShadow: '0px 4px 15px 0px #00000014' }}
      >
        <div
          datatype='left'
          className='flex flex-wrap gap-[8px]'
        >
          <div
            onClick={() => scrollToSection('duration')}
            className={cn(buttonClass, activeSection === 'duration' ? 'bg-black text-white' : '')}
          >
            Duration
          </div>
          <div
            onClick={() => scrollToSection('coverage')}
            className={cn(buttonClass, activeSection === 'coverage' ? 'bg-black text-white' : '')}
          >
            Coverage
          </div>
          <div
            onClick={() => scrollToSection('restrictions')}
            className={cn(buttonClass, activeSection === 'restrictions' ? 'bg-black text-white' : '')}
          >
            Restrictions
          </div>
          <div
            onClick={() => scrollToSection('customer-benefits')}
            className={cn(buttonClass, activeSection === 'customer-benefits' ? 'bg-black text-white' : '')}
          >
            Benefits
          </div>
          <div
            onClick={() => scrollToSection('one-unconditional-free-replacement')}
            className={cn(
              buttonClass,
              activeSection === 'one-unconditional-free-replacement' ? 'bg-black text-white' : '',
            )}
          >
            Replacement
            {/* <span className='text-secondary'>ONE&nbsp;</span> Unconditional{' '}
            <span className='text-secondary'>&nbsp;FREE&nbsp;</span> Replacement */}
          </div>

          <div
            onClick={() => scrollToSection('warranty-registeration')}
            className={cn(buttonClass, activeSection === 'warranty-registeration' ? 'bg-black text-white' : '')}
          >
            Registration
          </div>
          <div
            onClick={() => scrollToSection('contact-us')}
            className={cn(buttonClass, activeSection === 'contact-us' ? 'bg-black text-white' : '')}
          >
            Contact Us
          </div>
        </div>
      </div>
    </div>
  );
};
